jQuery(document).ready(function ($) {
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // Tables
  $('main').responsiveTables();
  $('main').responsivevideos();

  //Info Cards
  if ($(".info-cards").not('.info-cards.list').length) {
    $('.info-cards .col').wrapInner('<div class="content"></div>');
    $(".info-cards .col img").each(function () {
      $(this).unwrap('a');
      $(this).unwrap('p');
      $(this).insertBefore($(this).parent());
    });
  }

  //Full Width Call to Action
  if ($(".call-to-action.fw").length) {
    $(".call-to-action.fw .content .image").each(function () {
      $(this).parent().parent().css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      $(this).remove();
    });
  }

  //Featured Card
  if ($(".featured-card").length) {
    $(".featured-card .box-image").each(function () {
      $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
      $(this).find('img').remove();
    });
  }

  //Blog Categories
  $('.blog-category-title').click(function () {
    $('.blog-categories').toggleClass('active');
  });

  $('.blog-category-title').on('keypress', function (e) {
    if (e.which === 13) {
      $('.blog-categories').toggleClass('active');
    }
  });

  //Info Cards
  if ($(".recent-posts .post").length) {
    $('.recent-posts .post').first().wrap('<div class="featured-post"></div>');
    $('.recent-posts .post').first().wrapInner('<div class="content"></div>');
    $(".recent-posts .post:first img").each(function () {
      $(this).insertBefore($(this).parent());
    });
  }

  //Lincoln Quotes
  if ($(".quotes .no-results-text").length) {
    $(".quotes .start").remove();
  }

  if ($(".quotes .searched").length) {
    $(".quotes .start").remove();
  }

  //Breadcrumbs
  if ($(".breadcrumb li").length == 1) {
    $(".breadcrumb li").hide();
  }

  //Paging

  if ($(' ul.pagination li').length >= 5) {
    if ($(' ul.pagination li span').hasClass('active')) {

      $('ul.pagination li span.active').parent().prevAll().remove();
    }
  }

  //Events
  $('.event-dates h2 span:empty').parent().remove();

  //Subpage Banners
  if ($('.banner img').length > 1) {
    $(".banner img.default-img").remove();
  } else {
    $(".banner img.default-img").addClass('show');
  }

  //Subnavigation
  if ($('.subnavigation .ul2 li').hasClass('active')) {
    $('.subnavigation .ul2 li.active').parent().addClass('active');
  }


  if ($('.subnavigation .ul3 li').hasClass('active')) {
    $('.subnavigation .ul3 li.active').parent().addClass('active');
    $('.subnavigation .ul3 li.active').parent().parent().addClass('active');
    $('.subnavigation .ul3 li.active').parent().parent().parent().addClass('active');
    $('.subnavigation .ul3 li.active').parent().parent().children().addClass('active no-marker');
  }

  $('.subnavigation .ul1 li .a1').click(function () {
    $(this).next('ul').toggleClass('active');
  });

  $('.subnavigation .ul1 li .a1').on('keypress', function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      e.preventDefault();
      $(this).next('ul').toggleClass('active');
    }
  });

  //Custom Selectbox
  $('.selectbox-title').click(function () {
    $('.custom-selectbox').toggleClass('active');
    event.stopPropagation();
    //Click outside of open menu, close menu
    $(document).on('click', function (event) {
      if (!$(event.target).closest(".selectbox-title").length) {
        $('.custom-selectbox').removeClass('active');
      }
    });
  });

  $('.selectbox-title').on('keypress', function (e) {
    if (e.which === 13) {
      $('.custom-selectbox').toggleClass('active');
    }
    event.stopPropagation();
    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        $('.custom-selectbox.active').removeClass('active');
      }
    });
  });

  //Clear Date
  $('.date .clear-date').click(function () {
    $('input[type=date]').val('');
  });

});